var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticStyle:{"width":"100px"},attrs:{"size":_vm.size,"disabled":!_vm.canSendCode},on:{"click":_vm.sendCode}},[_c('span',{domProps:{"textContent":_vm._s(_vm.sendBtnText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }